import React, { useState } from 'react';
import './GenderSelection.css';

const GenderSelection = ({ onSelect }) => {
  const [selected, setSelected] = useState(null);
  
  const handleSelect = (gender) => {
    // Update selected state to show hover effect
    setSelected(gender);
    
    // Simulate a short delay to show the hover effect before proceeding
    setTimeout(() => {
      onSelect(gender);
    }, 500);
  };

  return (
    <div className="gender-selection-container">
      {/* <div className="logo-container">
        <div className="app-logo">
          <span className="logo-icon">🍴</span> YemekTarifleri.Ai
        </div>
      </div> */}
      
      <div className="selection-content">
        <h1>Bize kendinizden bahseder misiniz?</h1>
        <p className="selection-text">
          Size daha iyi bir deneyim sunmak için
          <br />cinsiyetinizi bilmemiz gerekiyor.
        </p>
        
        <div className="options-container">
          <button 
            className={`gender-option ${selected === 'male' ? 'selected' : ''}`}
            onClick={() => handleSelect('male')}
          >
            <div className="gender-label">Erkek</div>
          </button>
          
          <button 
            className={`gender-option ${selected === 'female' ? 'selected' : ''}`}
            onClick={() => handleSelect('female')}
          >
            <div className="gender-label">Kadın</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default GenderSelection; 